export const GeoData = {
  // to get Poi Layer Data from KYP api
  GET_POI_TYPE_LAYER_DATA: "GET_POI_TYPE_LAYER_DATA",
  GET_POI_TYPE_LAYER_DATA_SUCCESS: "GET_POI_TYPE_LAYER_DATA_SUCCESS",
  GET_POI_TYPE_LAYER_DATA_FAILURE: "GET_POI_TYPE_LAYER_DATA_FAILURE",
  // to remove "poiTypeLayerData"
  REMOVE_POI_TYPE_LAYER_DATA: "REMOVE_POI_TYPE_LAYER_DATA",
};
